import type { Session } from "../api";
import { sessionKey, useBusySessions } from "../sessionStore";
import { IconX } from "./icons";


export function SessionList({
  instance, sessions, currentSid, onSelect, onDelete, emptyLabel,
}: {
  instance: string;
  sessions: Session[];
  currentSid?: string;
  onSelect: (s: Session) => void;
  onDelete?: (s: Session) => void;
  emptyLabel?: string;
}) {
  // Runs keep going after you leave a session, so the list marks the ones still
  // waiting on the clerk.
  const busy = useBusySessions();
  if (sessions.length === 0) {
    return <div className="empty">{emptyLabel ?? "No chats yet."}</div>;
  }
  return (
    <div className="session-list">
      {sessions.map(s => (
        <div key={s.id} className="session-row">
          <a
            href="#"
            className={`session ${currentSid === s.id ? "active" : ""}`}
            onClick={e => { e.preventDefault(); onSelect(s); }}
            title={s.title}
          >
            <div className="session-title">
              {busy.has(sessionKey(instance, s.id)) && (
                <span className="session-busy" title="Waiting for the clerk" aria-label="Waiting for the clerk" />
              )}
              <span className="session-title-text">{s.title || "(untitled)"}</span>
            </div>
            <div className="ts">{relative(s.updated_at)}</div>
          </a>
          {onDelete && (
            <button
              className="session-del"
              title="Delete chat"
              aria-label="Delete chat"
              onClick={e => { e.preventDefault(); e.stopPropagation(); onDelete(s); }}
            >
              <IconX size={13} />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}


function relative(iso: string): string {
  const t = new Date(iso).getTime();
  const now = Date.now();
  const s = Math.max(0, Math.floor((now - t) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}
